<template lang="html">
    <div>

        <div class="row">
            <div class="col-sm-5">
                <input v-if="showInputName" class="w-100" type="text" name="" value="" placeholder="Widget Name" v-model="value.name">
            </div>
        </div>


        <div class="d-flex align-items-center mt-2 bg-lightest radius-normal border-light p-3 col-sm-12">
            <div class="row w-100">

                <div class="col-sm-12 d-flex mb-1">
                    <span class="bold pointer underlined mr-2" @click="allProductsInput(true)">Select All</span>
                    <span class="bold pointer underlined" @click="allProductsInput(false)">Clear All</span>
                </div>

                <div class="col-sm-12 px-3 pb-3 categoriesArea">
                    <div class="categoriesHolder p-2 bg-lighter radius-normal" v-for="category in value.categoryProductList">
                        <!-- Category -->
                        <div class="d-flex flex-row bold">
                            <checkbox v-model="category.widgetCategory.isActive" @input="categoryInput($event, category)"></checkbox>
                            {{category.widgetCategory.category.name}}
                            <i class="fas fa-cog ml-2 pointer dark fs-large" @click="openSettings(category)"></i>
                        </div>

                        <!-- Individual product -->
                        <div class="d-flex flex-row ml-2 mt-2" v-for="widgetProduct in category.widgetProducts">
                            <checkbox v-model="widgetProduct.isActive"></checkbox>
                            {{widgetProduct.product.name}}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    props:{
        value: {
            type: Object
        },
        showInputName: {
            type: Boolean,
            default: false
        },
        productOptions: {
            type: Array
        }
    },
    data: function () {
        return {
            productsArr: [],
            // widget: {
            //     "supplierId": 13,
            //     "supplier": null,
            //     "agentId": null,
            //     "agent": null,
            //     "id": null,
            //     "name": "All Productsaaabc",
            //     "isActive": true,
            //     "periodStart": null,
            //     "periodEnd": null,
            //     "products": [],
            //     "helper_allProducts": true
            // }
        }
    },
    created: function () {
        // creates a copy of all products just for this instance
        this.productsArr = JSON.parse(JSON.stringify(this.productOptions))

    },
    methods:{
        ...mapActions([
            'openModal',
            'selectWidgetCategory'
        ]),
        allProductsInput: function (val) {
            this.value.categoryProductList.map(category => {
                category.widgetCategory.isActive = val
                category.widgetProducts.map(widgetProduct => {
                    widgetProduct.isActive = val
                })
            })
        },
        categoryInput: function (val, category) {
            category.widgetProducts.map(product =>{
                product.isActive = val
            })
        },
        openSettings: function (category) {
            this.selectWidgetCategory(category.widgetCategory)
            this.openModal('WidgetAdvanced')
        }
    }
}
</script>

<style lang="scss" scoped>
.categoriesArea{

    margin: 0 auto;
    width: 500px;
    -moz-column-count: 3;
    -webkit-column-count: 3;
    column-count: 3;
    -moz-column-gap: 10px;
    -webkit-column-gap: 10px;
    column-gap: 10px;

    .categoriesHolder{
        width: 100%;
        margin: 10px 0;
        display: inline-block;
        box-sizing: border-box;
    }
}
</style>



// WEBPACK FOOTER //
// widgetComposer.vue?4b51be74